<template>
  <div class="container-fluid">
    <sideview
      :is-sidebar-active="sidebarActivated"
      :data="billing_info"
      @closeSidebar="toggleBillSidebar"
    />

    <b-modal
      v-model="whitelist_prompt"
      centered
      hide-footer
      title=""
    >
      <div class="vx-row">
        <h6 class="ml-5">
          Do you want to send this job for approval on telegram or do you want
          to approve it straight away to the job channel?
        </h6>
      </div>
      <div class="flex mx-2 my-8">
        <b-button
          class="vx-col w-1/2 mx-5"
          variant="primary"
          @click="sendWhich('admin_channel')"
        >Send to admin group on telegram</b-button>

        <b-button
          class="vx-col w-1/2 mx-5"
          variant="primary"
          @click="sendWhich('job_channel')"
        >Send to telegram job channel</b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="boost_popup"
      centered
      hide-footer
      :title="
        'Receive More Applicants To Your Job' + action_text === 'Boost Jobs'
          ? 's'
          : ''
      "
    >
      <div>
        <div class="vx-row my-4 mx-2">
          <b-card
            class="p-2"
          >
            <b-form-radio
              v-model="app_boost_gurantee"
              name="app_boost_gurantee"
              class="mx-2"
              value="application"
            >By Applications</b-form-radio>
            <div
              v-if="show_options.application"
              class="vx-row ml-2 mt-4"
            >
              <b-alert
                active="true"
                variant="warning"
                icon-pack="feather"
                icon="icon-info"
                class="h-auto"
              >
                <span>Tentatively Around S$0.40 - S$3.00 per application.</span>
              </b-alert>
            </div>
          </b-card>
        </div>

        <div class="vx-row my-4 mx-2">
          <b-card class="p-2 w-full">
            <b-form-radio
              v-model="app_boost_gurantee"
              name="app_boost_gurantee"
              class="mx-2"
              value="guaranteed"
            >By Guaranteed Placements</b-form-radio>
            <div
              v-if="show_options.guaranteed"
              class="vx-row w-full"
            >
              <div class="vx-row my-6 w-full mx-auto">
                <b-form-input
                  v-model="guaranteed_amount"
                  class="w-full ml-6"
                  placeholder="How much are you willing to pay for each placement?"
                />
              </div>

              <div class="vx-row my-6 w-full mx-auto">
                <b-form-input
                  v-model="guaranteed_period"
                  class="w-full ml-6"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  maxlength="8"
                  placeholder="Guaranteed placement period in days"
                />
              </div>
              <div
                v-if="guaranteed_period > 0"
                class="vx-row my-6 w-full mx-auto"
              >
                <b-form-textarea
                  v-model="payment_terms"
                  rows="4"
                  placeholder="Payment terms for the guaranteed placement period"
                  class="w-full ml-6"
                />
              </div>
            </div>
          </b-card>
        </div>
        <div class="x-row w-full my-6">
          <div class="vx-col w-1/2 mx-auto">
            <b-button
              v-if="!$store.state.auth.ActiveUser.email_address.includes('hhqmail')"
              variant="primary"
              class="w-64"
              @click="boostJob"
            >Boost Job{{ action_text === 'Boost Jobs' ? 's' : '' }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <div class="vx-row">
      <b-overlay
        :show="isStatsLoading"
        rounded="sm"
      >
        <b-card
          class="card-statistics"
        >
          <b-card-header>
            <b-card-title><h3>Overview</h3></b-card-title>
          </b-card-header>
          <b-card-body class="statistics-body">
            <div class="d-flex flex-row flex-wrap">
              <b-col
                v-for="item in statistics"
                :key="item.icon"
                class="mb-md-0"
                :class="item.color"
              >
                <div class="d-flex flex-row">
                  <div class="">
                    <b-avatar
                      size="64"
                      :variant="item.color"
                    >
                      <feather-icon
                        size="48"
                        :icon="item.icon"
                      />
                    </b-avatar>
                  </div>
                  <div class="mt-1 ml-1">

                    <b-card-text class=" mb-0">
                      <h4 class="font-weight-bolder">
                        {{ item.stats }}
                      </h4>
                    </b-card-text>
                    <p class="">
                      {{ item.title }}
                    </p>

                  </div>
                </div>
              </b-col>
            </div>
          </b-card-body>
        </b-card>
      </b-overlay>
    </div>

    <b-modal
      v-model="add_new_company"
      centered
      hide-footer
      title="Add a new company"
    >
      <div class="sm:vx-row mt-4">
        <h6 class="mb-2 mt-4">
          Company Name
        </h6>
        <b-form-input
          v-model="company_info.name"
          required
          class="w-full"
        />
        <h6 class="mb-2 mt-4">
          Company UEN NO
        </h6>
        <b-form-input
          v-model="company_info.uen_no"
          required
          class="w-full"
        />
        <h6 class="mb-2 mt-4">
          Primary SSIC
        </h6>
        <b-form-input
          v-model="company_info.primary_ssic"
          required
          class="w-full"
        />
        <h6 class="mb-2 mt-4">
          Secondary SSIC
        </h6>
        <b-form-input
          v-model="company_info.secondary_ssic"
          required
          class="w-full"
          placeholder="Leave empty if your company doesnt have a secondary ssic code"
        />
        <div class="vx-row mx-auto mt-8">
          <b-button
            class="mx-auto w-1/2"
            variant="warning"
            @click="createCompany"
          >Add company</b-button>
        </div>
      </div>
    </b-modal>

    <div
      v-if="!view_resume"
      id="data-list-list-view"
      class="vx-row data-list-container mb-6 mt-12"
      :class="{ hidden: !view_applicants }"
    >
      <b-modal
        v-model="popupHiring"
        centered
        hide-footer
        size="md"
        title="Share with others"
      >
        <div
          v-for="(shared, index) in shared_data"
          :key="index"
          class="vx-row mt-4 w-full"
        >
          <b-row class="mx-1">
            <h6>Applicant Name</h6>
            <b-form-input
              v-model="shared.fullname"
              class=""
              placeholder="Applicant Name"
              disabled
            />
            <div class="d-flex w-100 justify-content-between">
              <div class="mt-1">
                <h6>Applied Position</h6>
                <b-form-input
                  v-model="shared.applied_position"
                  class=""
                  placeholder="Applied Position"
                  disabled
                />
              </div>

              <div class="mt-1">
                <h6>Applied Company</h6>
                <b-form-input
                  v-model="shared.employer"
                  class=""
                  placeholder="Applied Company"
                  disabled
                />
              </div>
            </div>
          </b-row>

          <b-row class="mx-1 mt-1">
            <h6 class="">
              Hiring Manager Email
            </h6>

            <b-form-group
              class="w-100"

              :label-for="shared.hiring_manager_email"
            >

              <b-form-input
                :id="shared.hiring_manager_email"
                v-model="shared.hiring_manager_email"
                :state="shared.hiring_manager_email"
                class="w-full"
                placeholder="Hiring Manager Email"
              />
              <b-form-invalid-feedback>
                A valid Hiring Manager Email is required.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-row>
          <b-row class="mx-1">
            <h6 class="mb-2 mt-1">
              Note
            </h6>
            <b-form-textarea
              v-model="shared.note"
              class="w-full"
              @change="latest_update(shared.note)"
            />
          </b-row>

          <b-row class="mx-1 mt-1 w-100 mb-1">
            <div class="d-flex justify-content-between w-100 mr-2">
              <b-button
                class=""
                variant="primary"
                @click="
                  downloadResume(
                    current_applicant.userid,
                    current_applicant.resume,
                    current_applicant.app_id,
                  )
                "
              >
                Preview Resume
              </b-button>

              <b-button
                class=""
                variant="success"
              >
                Replace resume
              </b-button>
            </div>
          </b-row>

          <b-row class="mx-1 mt-2">
            <h6>Applicant email :</h6>
            <b-form-radio
              v-model="shared.mask_email"
              name="mask_email"
              class="mx-2"
              :value="shared.mask_email_mask"
              @change="latest_update()"
            >Mask</b-form-radio>
            <b-form-radio
              v-model="shared.mask_email"
              name="mask_email"
              class="mx-1"
              :value="shared.mask_email_unmask"
              @change="latest_update()"
            >Unmask</b-form-radio>
            <b-form-radio
              v-model="shared.mask_email"
              name="mask_email"
              class="mx-1"
              :value="shared.mask_email_hide"
              @change="latest_update()"
            >Hide</b-form-radio>
          </b-row>

          <b-alert
            v-if="
              getMaskInfo(
                'email',
                shared.mask_email,
                shared.mask_email_mask,
                shared.mask_email_unmask,
                shared.mask_email_hide,
              )
            "
            show
            variant="warning"
            icon-pack="feather"
            icon="icon-info"
            class="p-2"
          >{{
            getMaskInfo(
              'email',
              shared.mask_email,
              shared.mask_email_mask,
              shared.mask_email_unmask,
              shared.mask_email_hide,
            )
          }}
          </b-alert>

          <b-row class="mx-1 mt-2">
            <h6>Applicant number :</h6>
            <b-form-radio
              v-model="shared.mask_contact"
              name="mask_contact"
              class="mx-2"
              :value="shared.mask_contact_mask"
              @change="latest_update()"
            >Mask</b-form-radio>
            <b-form-radio
              v-model="shared.mask_contact"
              name="mask_contact"
              class="mx-1"
              :value="shared.mask_contact_unmask"
              @change="latest_update()"
            >Unmask</b-form-radio>
            <b-form-radio
              v-model="shared.mask_contact"
              name="mask_contact"
              class="mx-1"
              :value="shared.mask_contact_hide"
              @change="latest_update()"
            >Hide</b-form-radio>
          </b-row>
          <b-alert
            v-if="
              getMaskInfo(
                'phone_number',
                shared.mask_contact,
                shared.mask_contact_mask,
                shared.mask_contact_unmask,
                shared.mask_contact_hide,
              )
            "
            show
            variant="warning"
            icon-pack="feather"
            icon="icon-info"
            class="p-2"
          >{{
            getMaskInfo(
              'phone_number',
              shared.mask_contact,
              shared.mask_contact_mask,
              shared.mask_contact_unmask,
              shared.mask_contact_hide,
            )
          }}
          </b-alert>
          <hr v-if="shared_data.length > 1">
        </div>

        <div class="vx-row my-2">
          <b-button
            class="mr-2 w-100"
            variant="warning"
            @click="proceedShare(shared_data)"
          >Proceed to share application</b-button>
        </div>
      </b-modal>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <b-card class="p-3">

          <div class="d-flex justify-content-between">

            <div class="ml-1">
              <b-row>
                <b-button
                  variant="warning"
                  icon-pack="feather"
                  icon="icon-chevron-left"
                  @click="view_applicants = false"
                >Back</b-button>
              </b-row>
              <b-row>
                <b-badge
                  pill
                  class="mt-1"
                  variant="dark"
                >Position : {{ specified_position }}</b-badge>
              </b-row>

            </div>
            <div class="flex flex-row">
              <b-dropdown
                v-if="!hide_for_now"
                style="height: 40px;min-width: 180px;"
                split
                variant="dark"
                :text="action_text"
                right
                :icon="action_icon"
                type="filled"
                class="cursor-pointer "
                @click="performAction"
              >

                <b-dropdown-item @click="changeAction('Actions')">
                  <span class="d-flex justify-content-left">
                    <feather-icon
                      icon="InfoIcon"
                      svg-classes="h-4 w-4"
                      class="mr-1"

                      size="18"
                    />
                    <span class="w-32">Actions</span>
                  </span>
                </b-dropdown-item>
                <!-- <b-dropdown-item
                  v-if="!$store.state.auth.ActiveUser.email_address.includes('hhqmail')"
                  @click="changeAction('Boost Job')"
                >
                  <span class="d-flex justify-content-center">
                    <feather-icon
                      icon="TrendingUpIcon"
                      svg-classes="h-4 w-4"
                      class="mr-2"
                    />
                    <span class="w-32">Boost Job</span>
                  </span>
                </b-dropdown-item> -->
                <b-dropdown-item
                  v-if="
                    $store.state.auth.ActiveUser.account_type === this.$UserGroups.AGENCY
                  "
                  @click="changeAction('Share with others')"
                >
                  <span class="d-flex justify-content-center">
                    <feather-icon
                      icon="ShareIcon"
                      svg-classes="h-4 w-4"
                      class="mr-1"
                    />
                    <span class="w-32">Share with others</span>
                  </span>
                </b-dropdown-item>

              </b-dropdown>

            </div>
          </div>

        </b-card>
      </b-overlay>
    </div>

    <b-modal
      v-model="popupActivity"
      centered
      hide-footer
      size="md"
      title="Application Activity"
    >

      <ul
        v-if="currentActivity.length > 0"
        class="p-1"
      >
        <li
          v-for="(activity, index) in currentActivity"
          :key="index"
          class="p-1"
        >{{ activity }}</li>
      </ul>

      <h6 v-else>
        No Activities
      </h6>

    </b-modal>

    <b-modal
      v-model="popupResume"
      centered
      hide-footer
      size="lg"
      title="Applicant Information"
      style="height: 100%!important"
    >
      <div
        v-if="resume_processing"
        class="p-1 mx-auto"
      >
        <b-row>
          <b-spinner
            class="mx-auto"
            type="grow"
            variant="warning"
            label="Loading..."
          />
        </b-row>
        <b-row class="mt-1">
          <h6 class="mx-auto text-warning">
            We are still processing the applicant's resume. Please check again later.
          </h6>
        </b-row>

      </div>
      <iframe
        v-else
        :src="file_source"
        width="100%"
        style="min-height: 100vh!important;"
        frameborder="0"
      />

    </b-modal>

    <div
      id="data-list-list-view"
      class="vx-row w-full data-list-container mb-3 mt-12"
      :class="{ hidden: view_applicants }"
    >
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <b-card
          id="jobs-table"
          class="w-full p-2"
        >
          <b-col
            v-if="!hide_for_now"

            cols="12"
            class="mb-5"
          >
            <b-dropdown
              class="float-right "
              style="height: 40px;min-width: 180px;"
              split
              :variant="action_view"
              :text="action_text"
              right
              @click="performAction"
            >
              <b-dropdown-item @click="changeAction('Actions')">
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="InfoIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Actions</span>
                </span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$checkRights(this.$route.meta.section, 'write')"
                @click="changeAction('Post Jobs')"
              >
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="PlusIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Post Jobs</span>
                </span>
              </b-dropdown-item>

              <!-- <b-dropdown-item
                v-if="$checkRights(this.$route.meta.section, 'update')"
                @click="changeAction('Repost Jobs')"
              >
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="RotateCwIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Repost Jobs</span>
                </span>
              </b-dropdown-item> -->
              <!-- <b-dropdown-item
                v-if="!$store.state.auth.ActiveUser.email_address.includes('hhqmail')"
                @click="changeAction('Boost Job')"
              >
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="TrendingUpIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1"
                  />
                  <span class="w-32">Boost Job</span>
                </span>
              </b-dropdown-item> -->

              <!-- <b-dropdown-item
                v-if="$checkRights(this.$route.meta.section, 'update')"
                @click="changeAction('Edit Jobs')"
              >
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="EditIcon"
                    svg-classes="h-4 w-4"
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Edit Jobs</span>
                </span>
              </b-dropdown-item> -->

              <!-- <b-dropdown-item
                v-if="$checkRights(this.$route.meta.section, 'delete')"
                @click="changeAction('Archive Jobs')"
              >
                <span class="d-flex justify-content-left">
                  <feather-icon
                    icon="ArchiveIcon"
                    svg-classes=""
                    class="mr-1 icon-spacing"
                  />
                  <span class="w-32">Archive Jobs</span>
                </span>
              </b-dropdown-item> -->

            </b-dropdown>
          </b-col>

          <vue-good-table
            class="my-1"
            theme="polar-bear"
            mode="remote"
            :columns="jobColumns"
            :rows="jobs"
            :total-rows="totalRecords"
            :search-options="{
              enabled: false,

            }"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: false, // disable the select info panel on top
              selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"

            :pagination-options="{
              enabled: true,
              perPage: serverParams.perPage,
              perPageDropdown: [5, 10, 20, 50, 100],
              dropdownAllowAll: false,
            }"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            @on-selected-rows-change="onSelectionChange"
          >
            <template
              slot="column-filter"
              slot-scope="props"
            >
              <!-- <span
                v-if="props.column.field === 'interview'"
              >

                <v-select
                  :options="interviewOptions"
                  class=""
                  @input="onJobColumnFilter($event, props)"
                />
              </span> -->
            </template>

            <template
              slot="table-row"
              slot-scope="props"
            >
              <!-- Column: Status -->
              <span v-if="props.column.field === 'days'">
                <b-row class="mx-auto">
                  <h6 v-if="props.row.days > 0 && props.row.active">{{ props.row.days }}</h6>
                  <h6 v-else>Closed</h6>
                </b-row>

                <b-row class="w-100 mx-auto">
                  <div
                    v-if="props.row.days > 0 && props.row.active"
                    :class="`progress w-100 progress-bar-custom-${props.row.days <= 30 ? Math.floor(props.row.progress) : 100 }`"
                  >
                    <div
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      :aria-valuenow="props.row.progress"
                      class="progress-bar"
                      :style="`width: ${props.row.progress}%;`"
                    />
                  </div>
                  <div
                    v-else
                    :class="`progress w-100 progress-bar-custom-0`"
                  >
                    <div
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      :aria-valuenow="props.row.progress"
                      class="progress-bar"
                      :style="`width: 100%;`"
                    />
                  </div>
                </b-row>
              </span>

              <span v-else-if="props.column.field === 'post_channel'">
                <div class="d-flex flex-wrap flex-gap-xs">
                  <b-badge
                    v-for="channel in props.row.post_channel"
                    :key="channel.key"
                    variant="light-warning"
                  >
                    {{ platforms[channel] }}
                  </b-badge>
                </div>
              </span>

              <!-- <span v-else-if="props.column.field === 'interview'">
                <b-badge :variant="'light-'+getInterviewColor(props.row.interview)">
                  {{ props.row.interview }}
                </b-badge>
              </span> -->

              <span v-else-if="props.column.field === 'applications'">
                <div class="d-flex justify-content-start w-100">
                  <b-badge variant="light-primary">
                    {{ props.row.applications }} Applications
                  </b-badge>
                </div>
              </span>

              <span v-else-if="props.column.field === 'actions'">
                <div class="self-center">
                  <div class="d-flex flex-wrap flex-gap-xs">
                    <!-- View -->
                    <b-button
                      v-b-tooltip.hover.top="'Click here to view Applications'"
                      class="btn-icon small-space"
                      variant="outline-dark"
                      @click="showApplicants(props.row)"
                    >
                      <feather-icon
                        icon="EyeIcon"
                        svg-classes="hover:text-primary stroke-current"
                      />
                    </b-button>

                    <!-- Edit -->
                    <b-button
                      v-if="$checkRights($route.meta.section, 'update')"
                      v-b-tooltip.hover.top="'Edit this job'"
                      class="btn-icon small-space"
                      variant="outline-dark"
                      @click="editATSJob(props.row)"
                    >
                      <feather-icon
                        icon="EditIcon"
                        svg-classes="hover:text-primary stroke-current"
                      />
                    </b-button>

                    <!-- Edit -->
                    <b-button
                      v-if="$checkRights($route.meta.section, 'update')"
                      v-b-tooltip.hover.top="'Repost this job'"
                      class="btn-icon small-space"
                      variant="outline-dark"
                      @click="repostATSJob(props.row)"
                    >
                      <feather-icon
                        icon="RotateCwIcon"
                        svg-classes="hover:text-primary stroke-current"
                      />
                    </b-button>

                    <!-- Close -->
                    <b-button
                      v-if="$checkRights($route.meta.section, 'delete')"
                      v-b-tooltip.hover.top="`Close this job`"
                      class="btn-icon small-space"
                      variant="outline-dark"
                      @click="deleteATSJob(props.row)"
                    >
                      <feather-icon
                        class="text-danger"
                        icon="Trash2Icon"
                        svg-classes="hover:text-primary stroke-current"
                      />
                    </b-button>

                    <!-- Reactivate -->
                    <!-- <b-button
                      v-else-if="$checkRights(this.$route.meta.section, 'delete') && !params.account_approved"
                      v-b-tooltip.hover.top="'Reactivate this user'"
                      class="btn-icon small-space"
                      variant="outline-dark"
                      @click="confirmReactivateRecord"
                    >
                      <feather-icon
                        class="text-success"
                        icon="RotateCcwIcon"
                        svg-classes="hover:text-primary stroke-current"
                      />
                    </b-button> -->
                  </div>
                </div>
              </span>

              <!-- Column: Common -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </b-card>
      </b-overlay>
    </div>

    <div
      v-if="view_resume"
      class="vx-row mb-6 mt-12"
    >
      <b-card class="w-full">
        <div class="vx-row mx-5">
          <b-button
            variant="warning"
            icon-pack="feather"
            icon="icon-chevron-left"
            @click="show_applications"
          >Back</b-button>
        </div>

        <div class="vx-row mt-5 h-screen">
          <iframe
            id="resume_frame"
            :srcdoc="html_resume_content"
            width="100%"
            height="100%"
            frameborder="0"
          />
        </div>
      </b-card>
    </div>

    <div
      v-if="app_sources"
      class="vx-row my-6"
    >
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
        <b-card
          title="Applicant Sources"
          class="mt-base"
        >
          <div
            v-for="(source, index) in trafficSources"
            :key="index"
          >
            <div class="flex justify-between">
              <div class="flex flex-col">
                <span class="mb-1">{{ source.name }}</span>
                <h4>{{ source.ratio }}%</h4>
              </div>

              <div class="flex flex-col text-right">
                <span class="flex -mr-1">
                  <feather-icon
                    class="p-3 inline-flex rounded-full mb-1 mx-6"
                    :class="[`text-${source.color}`]"
                    size="medium"
                    :icon="[source.icon]"
                    :style="{
                      background: `rgba(var(--vs-${source.color}),.15)`,
                    }"
                  />
                </span>
              </div>
            </div>
            <b-progress
              :percent="source.ratio"
              variant="warning"
            />
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import Sideview from '@/views/payments/Sideview.vue'
import DataViewSidebar from '@/layouts/components/DataViewSidebar.vue'
import vSelect from 'vue-select'
import { debounce } from 'lodash'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import {
  BCard,
  BFormGroup,
  BFormInput,
  BButton,
  BRow,
  BCol,
  BModal,
  VBModal,
  BBadge,
  BAvatar,
  BOverlay,
  BFormCheckbox,
  BFormInvalidFeedback,
  BPagination,
  BFormSelect,
  BProgress,
  BDropdown,
  BDropdownItem,
  BCardHeader,
  BCardBody,
  BCardText,
  BCardTitle,
  BFormRadio,
  BFormTextarea,
  BAlert,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'

import CellRendererActions from './cell-renderer/CellRendererActions.vue'

export default {
  components: {
    VueGoodTable,
    BFormRadio,
    BAlert,
    BCardHeader,
    BCardBody,
    BCardText,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    BProgress,
    BPagination,
    BFormSelect,
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    BRow,
    BCol,
    BModal,
    VBModal,
    BBadge,
    BAvatar,
    BOverlay,
    BFormCheckbox,
    BFormInvalidFeedback,

    DataViewSidebar,
    Sideview,

    'v-select': vSelect,

    CellRendererActions,
  },
  data() {
    return {
      platforms: {
        mycareersfuture: 'MyCareersFuture',
        jobsdb: 'JobsDB',
        glints: 'Glints',
        jobs007: 'Jobs007',
        jobstreet: 'JobStreet',
        pmet: 'PMET',
        non_pmet: 'Non PMET',
        siso: 'SISO WSH',
      },
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 4,
      },
      totalRecords: 0,
      activeTab: 0,
      guaranteed_amount: '',
      guaranteed_period: 0,
      payment_terms: '',
      credits: {},
      other_platforms: [
        { name: 'MyCareersFuture', destination: 'mycareersfuture' },
        { name: 'JobStreet', destination: 'jobstreet' },
        { name: 'JobsDB', destination: 'jobsdb' },
        { name: 'Workclass', destination: 'workclass' },
        // { name: "GrabJobs", destination: "grabjobs" },
        // { name: "CultJobs", destination: "cultjobs" },
      ],
      main_job_types: '',
      popupResume: false,
      file_source: '',
      whitelist_prompt: false,
      show_switch: false,
      switch_disable: true,
      which_data: true,
      phone_number: '',
      confirmation_code: '',
      html_resume_content: '',
      account_type: 'agency',
      hiring_note: '',
      shared_data: {},
      show_bulk: true,
      add_new_company: false,
      hide_for_now: false,
      select_company: '',
      select_industry: [],
      edit_job_ids: [],
      popupHiring: false,
      sharing_info: '',
      hiring_manager_email: null,
      current_employer: '',
      current_applicant: {},
      company_info: {},
      application_ids: [],
      selected_status: '',

      employers: [
        { text: 'Start typing to get employer suggestions', value: null },
      ],
      action_view: 'dark',
      action_text: 'Actions',
      action_icon: 'info_outline',
      client_profile: '',
      selected_jobs: [],
      selected_job: {},
      action_bar: false,
      app_sources: false,
      isMounted: false,
      view_applicants: false,
      view_resume: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      jobs: [],
      specified_position: '',

      items_deletion: [],
      statistics: [
        {
          title: 'Total Jobs',
          stats: 0,
          icon: 'DatabaseIcon',
          color: 'light-warning',
        },
        {
          title: 'Open Jobs',
          stats: 0,
          icon: 'FileTextIcon',
          color: 'light-warning',
        },
        {
          title: 'Applications',
          stats: 0,
          icon: 'PieChartIcon',
          color: 'light-primary',
        },
        {
          title: 'Interviews Conducted',
          stats: 0,
          icon: 'VideoIcon',
          color: 'light-success',
        },
        {
          title: 'Applicant Sources',
          stats: 0,
          icon: 'CloudIcon',
          color: 'light-danger',
        },
      ],
      trafficSources: [
        {
          name: 'Facebook',
          icon: 'FacebookIcon',
          ratio: 0,
          color: 'warning',
        },
        {
          name: 'Twitter',
          icon: 'TwitterIcon',
          ratio: 0,
          color: 'warning',
        },
        {
          name: 'Linkedin',
          icon: 'LinkedinIcon',
          ratio: 0,
          color: 'warning',
        },
        {
          name: 'Instagram',
          icon: 'InstagramIcon',
          ratio: 0,
          color: 'warning',
        },
        {
          name: 'Telegram',
          icon: 'SendIcon',
          ratio: 0,
          color: 'warning',
        },
        {
          name: 'Others',
          icon: 'CloudIcon',
          ratio: 0,
          color: 'warning',
        },
      ],
      file_upload: '',
      update_popup: false,
      bulk_upload: false,
      job_expiry: '',
      published_fields: {
        vacancies: false,
        salary: false,
        employer: false,
      },
      job_type: {
        parttime: false,
        freelance: false,
        fulltime: false,
        internship_traineeship: false,
        flexiwork: false,
        permanent: false,
        contract: false,
        temporary: false,
      },
      number_of_channels: {
        e2i: 3,
        persolkelly: 1,
        steadylah: 1,
        main: 1,
      },
      optional: {
        team: '',
        union: '',
        destination: {
          siso: false,
          pmet: false,
          non_pmet: false,
          steadylah: false,
          persolkelly: false,
          main: false,
        },
        vacancies: '',
        questions: '',
        poster_email: '',
        hiring_manager_email: '',
      },
      send_where: 'admin_channel',
      position: '',
      description: '',
      requirements: '',
      type_candidate: '',
      work_days: '',
      work_hours: '',
      salary: '',
      min_salary: '',
      yoe: '',
      job_level: '',
      work_location: '',
      posted_on: '',
      remote: false,
      applications: [],
      popupActive: false,
      popupApplicant: false,
      boost_popup: false,
      applicant_info: {},
      viewJob: false,
      popupList: false,
      app_gurantee: '',
      app_boost_gurantee: '',
      show_options: {
        application: false,
        guaranteed: false,
      },

      title: 'Add Job',

      action: 'insert',
      registered: [],
      current_item: {},
      item_id: '',
      events_data: [],
      select_tags: [],
      all_position_levels: [
        {
          text: 'Senior Manager',
          value: 'Senior Manager',
        },
        {
          text: 'Manager',
          value: 'Manager',
        },
        {
          text: 'Senior Executive',
          value: 'Senior Executive',
        },
        {
          text: 'Junior Executive',
          value: 'Junior Executive',
        },
        {
          text: 'Entry Level',
          value: 'Entry Level',
        },
        {
          text: 'Non-Executive',
          value: 'Non-Executive',
        },
      ],

      all_portals: [
        'mycareersfuture',
        'jobstreet',
        'jobsdb',
        'workclass',
        'grabjobs',
        'cultjobs',

        'pmet',
        'siso',
        'non_pmet',
        'persolkelly',
      ],
      categories: [
        {
          text: 'Accommodation and food service activities',
          value: 'Accommodation and food service activities',
        },
        {
          text: 'Administrative and support service activities',
          value: 'Administrative and support service activities',
        },
        { text: 'Agriculture and fishing', value: 'Agriculture and fishing' },
        {
          text: 'Arts, entertainment and recreation',
          value: 'Arts, entertainment and recreation',
        },
        { text: 'Construction', value: 'Construction' },
        { text: 'Education', value: 'Education' },
        {
          text: 'Electricity,gas,steam and air-conditioning supply',
          value: 'Electricity,gas,steam and air-conditioning supply',
        },
        {
          text: 'Financial and insurance activities',
          value: 'Financial and insurance activities',
        },
        {
          text: 'Health and social services',
          value: 'Health and social services',
        },
        {
          text: 'Information and communications',
          value: 'Information and communications',
        },
        { text: 'Manufacturing', value: 'Manufacturing' },
        { text: 'Mining and quarrying', value: 'Mining and quarrying' },
        {
          text: 'Other service activities',
          value: 'Other service activities',
        },
        {
          text: 'Professional, scientific and technical activities',
          value: 'Professional, scientific and technical activities',
        },
        {
          text: 'Public administration and defence',
          value: 'Public administration and defence',
        },
        { text: 'Real estate activities', value: 'Real estate activities' },
        {
          text: 'Transportation and storage',
          value: 'Transportation and storage',
        },
        {
          text: 'Water supply;sewerage waste management and remediation activities',
          value:
            'Water supply;sewerage waste management and remediation activities',
        },
        {
          text: 'Wholesale and retail trade',
          value: 'Wholesale and retail trade',
        },
      ],
      customer_email: '',
      sidebarActivated: false,
      proceed_transaction: false,
      billing_info: {},
      publishableKey: process.env.VUE_APP_STRIPE_KEY,
      packageItems: [
        {
          price: 'price_1Jhl41I2ri5g5XG9J7zkSEga',
          //  price: "price_1IybHQI2ri5g5XG9t1EMtk2H",
          quantity: 1,
        },
      ],
      successURL: 'https://dashboard.headhuntershq.com/payment-success',
      cancelURL: 'https://dashboard.headhuntershq.com/applicant-tracking',
      payment_id: '',
      skip: 0,
      skip_page: 1,
      limit: 4,
      total_open_jobs: 0,
      extra_filters: '',
      searchTimer: null,
      sort_search_options: {
        applications: {
          sort: null,
          query: '',
        },
        position: {
          sort: null,
          query: '',
        },
        poster: {
          sort: null,
          query: '',
        },
        employer: {
          sort: null,
          query: '',
        },
        days: {
          sort: null,
          query: '',
        },
        interview: {
          sort: null,
          query: '',
        },
        applied_on: {
          sort: null,
          query: '',
        },

        status: {
          sort: null,
          query: '',
        },

        note: {
          sort: null,
          query: '',
        },

        contact: {
          sort: null,
          query: '',
        },

        email: {
          sort: null,
          query: '',
        },

        fullname: {
          sort: null,
          query: '',
        },
      },
      isLoading: true,
      isStatsLoading: true,

      itemsPerPageJobs: 4,
      itemsPerPageApp: 4,
      dir: false,
      jobColumns: [

      ],

      rows: [],
      verifyType: 'phoneNumber',
      openVerifyPopup: false,
      loadingNumber: false,
      currentActivity: [],
      popupActivity: false,
      resume_processing: false,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 5,
      },
      totalRecords: 0,
    }
  },

  computed: {
    totalJobPages() {
      return Math.round(this.total_open_jobs / this.itemsPerPageJobs)
    },
    currentJobsPage() {
      if (this.isMounted) {
        return this.$refs.table_jobs.currentx
      }
      return 0
    },
    currentAppPage() {
      if (this.isMounted) {
        if (this.$refs.table_applicants) {
          return this.$refs.table_applicants.currentx
        }
        return 1
      }
      return 0
    },
    queriedJobsItems() {
      return Math.round(this.total_open_jobs / this.itemsPerPageJobs)
    },
    queriedAppItems() {
      return this.$refs.table_applicants
        ? this.$refs.table_applicants.queriedResults.length
        : this.applicants.length
    },
  },

  watch: {
    itemsPerPageJobs(val) {
      this.limit = this.itemsPerPageJobs

      this.getJobs()
    },
    skip_page(val) {
      this.skip = (val - 1) * this.itemsPerPageJobs
      this.limit = this.itemsPerPageJobs
      this.getJobs()
    },
    app_gurantee(val) {
      if (val === 'guaranteed') {
        this.show_options.guaranteed = true
        this.show_options.application = false
      } else if (val === 'application') {
        this.show_options.application = true
        this.show_options.guaranteed = false
      }

      const button = document.querySelector(
        '.wizard-footer-right > span > .wizard-btn',
      )
      if (button) {
        button.innerHTML = 'Next'
      }
    },
    app_boost_gurantee(val) {
      if (val === 'guaranteed') {
        this.show_options.guaranteed = true
        this.show_options.application = false
      } else if (val === 'application') {
        this.show_options.application = true
        this.show_options.guaranteed = false
      }

      const button = document.querySelector(
        '.wizard-footer-right > span > .wizard-btn',
      )
      if (button) {
        button.innerHTML = 'Next'
      }
    },
    main_job_types(val) {
      if (val === 'fulltime') {
        this.job_type.fulltime = true
        this.job_type.parttime = false
      } else {
        this.job_type.fulltime = false
        this.job_type.parttime = true
      }
    },
    which_data(val) {
      this.isLoading = true
      this.jobs = []
      this.statistics = [
        {
          title: 'Total Jobs',
          stats: 0,
          icon: 'DatabaseIcon',
          color: 'light-warning',
        },
        {
          title: 'Open Jobs',
          stats: 0,
          icon: 'FileTextIcon',
          color: 'light-warning',
        },
        {
          title: 'Applications',
          stats: 0,
          icon: 'PieChartIcon',
          color: 'light-primary',
        },
        {
          title: 'Interviews Conducted',
          stats: 0,
          icon: 'VideoIcon',
          color: 'light-success',
        },
        {
          title: 'Applicant Sources',
          stats: 0,
          icon: 'CloudIcon',
          color: 'light-danger',
        },
      ]

      this.getJobs()
    },
  },
  created() {
    this.jobColumns = this.initJobColumns()
    const { user_group } = this.$store.state.auth.ActiveUser
    if (['temporary'].some(el => user_group.includes(el))) {
      this.hide_for_now = true
      this.account_type = 'temporary'
    }

    if (this.$store.state.auth.ActiveUser.company_name !== 'PersolKelly') {
      this.which_data = false
      this.show_switch = false
    } else {
      this.show_switch = true
      this.which_data = true
      if (this.$store.state.auth.ActiveUser.user_group.includes(this.$UserGroups.SUPERUSER)) {
        this.which_data = false
        this.switch_disable = false
      }
    }
    if (this.$store.state.auth.ActiveUser.view_all) {
      this.switch_disable = false
    }
    // this.popupActive = true;
    // this.isLoading = true;
    if (this.$store.state.auth.ActiveUser.company_uen_no === this.$CompanyUen.E2I) {
      // this.optional.destination = false;
    }

    this.getCredits()
  },

  mounted() {
    try {
      const next = this.$children[0].$refs.btnclose
      next.$el.addEventListener('click', this.onClickCloseButton, false)
    } catch (error) {}

    this.isMounted = true
    this.isLoading = true
    this.getStats()

    this.getJobs()
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
      this.getJobs()
    },
    onPageChange(params) {
      const prevSelectedROws = this.selectedRows
      this.updateParams({ page: params.currentPage })
      this.updateParams({ selectedRows: prevSelectedROws })
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
    },
    onSortChange(params) {
      if (params[0]) {
        const fieldName = params[0].field
        const sortDetails = { }
        sortDetails[fieldName] = params[0].type
        this.updateParams({ sort: sortDetails })
      }
    },
    onColumnFilter(params) {
      this.serverParams.page = 1
      this.updateParams(params)
    },
    onSelectionChange(params) {
      this.selectedRows = params.selectedRows
      this.selected_jobs = params.selectedRows
    },
    updateFilters(column, value) {
      const currentFilters = this.serverParams.columnFilters
      currentFilters[column] = value
      this.updateParams({ columnFilters: currentFilters })
    },

    onJobColumnFilter: debounce(function (params) {
      // params.columnFilters - filter values for each column in the following format:
      // {field1: 'filterTerm', field3: 'filterTerm2')

      Object.entries(params.columnFilters).map(([field, query]) => {
        if (query.length > 0) {
          Object.assign(this.sort_search_options[field], {
            query,
            sort: null,
          })
        } else {
          Object.assign(this.sort_search_options[field], {
            query: '',
            sort: null,
          })
        }
        return null
      })
      this.getJobs()
    // sort_search_options.fullname.query
    }, 1000),

    onJobProgressFilter: debounce(function (params, props = null, option = null) {
      // const [field, query] = Object.entries(params.columnFilters)[0]
      const query = params.data
      const field = `${props.column.field}_${option}` // Ex. days_min / days_max

      if (query.length > 0) {
        this.sort_search_options[field] = {
          query,
          sort: null,
        }
      } else {
        this.sort_search_options[field] = {
          query: '',
          sort: null,
        }
      }
      this.getJobs()
    // sort_search_options.fullname.query
    }, 1000),

    onJobSortChange(params) {
      this.changeSorting(params[0].field, params[0].type)
    // params[0].sortType - ascending or descending
    // params[0].columnIndex - index of column being sorted
    },
    selectionJobChanged(params) {
      this.selected_jobs = params.selectedRows
    },

    getMaskInfo(mask_type, mask_model, mask, unmask, hide) {
      if (mask_type === 'email') {
        if (mask_model === mask) {
          return 'The receiving party would only be able to contact the Job Seeker via an auto-generated email address. Email address in resume will be shown as "—Masked Email—".'
        }
        if (mask_model == unmask) {
          return 'The receiving party would be able to contact the Job Seeker via his/her email address. Email address in resume will not be masked.'
        }
        if (mask_model === hide) {
          return 'The receiving party would not be able to contact the Job Seeker via his/her email address. Email address in resume will be shown as "—Masked Email—".'
        }
        return ''
      }
      if (mask_type === 'phone_number') {
        if (mask_model === mask) {
          return 'The receiving party would only be able to contact the Job Seeker via an auto-generated masked mobile number. Contact number in resume will be shown as "—Masked Number—".'
        }
        if (mask_model == unmask) {
          return 'The receiving party would be able to contact the Job Seeker via his/her mobile number. Contact number in resume will not be masked.'
        }
        if (mask_model === hide) {
          return 'The receiving party would not be able to contact the Job Seeker via his/her mobile number. Contact number in resume will be shown as "—Masked Number—".'
        }
        return ''
      }
      return ''
    },
    searchTextChange(col_name) {
      this.getJobs()
    },
    changeSorting(col_name, sort_type = null) {
      Object.entries(this.sort_search_options).map(([field, query]) => {
        Object.assign(this.sort_search_options[field], {
          sort: null,
        })
        return null
      })
      switch (sort_type) {
        case null:
          Object.assign(this.sort_search_options[col_name], {
            sort: 'asc',
          })
          break
        case 'asc':
          Object.assign(this.sort_search_options[col_name], {
            sort: 'desc',
          })
          break
        case 'desc':
          Object.assign(this.sort_search_options[col_name], {
            sort: null,
          })
          break
        default:
          Object.assign(this.sort_search_options[col_name], {
            sort: null,
          })
      }

      this.getJobs()
    },
    boostJob() {
      const all_data = {
        type: 'events',
        job_id: this.params.data._id,
        boost_type: this.show_options,
        guaranteed_period: this.guaranteed_period,
        guaranteed_amount: this.guaranteed_amount,
        payment_terms: this.payment_terms,
      }

      this.$http
        .put('/api/boost-job', { data: all_data })
        .then(response => {
          const { success } = response.data
          if (success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Event Manager Notification',
                  icon: 'AlertCircleIcon',
                  text: 'Your job has been boosted successfully',
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        })
        .catch(error => {})
      this.boost_popup = false
    },
    handleStatusChange(newVal, oldVal) {
      if (newVal.status !== oldVal.status) {
        this.restoreCreds()
        this.$http
          .put('/api/update-application', { data: newVal })
          .then(response => {
            const { success } = response.data

            if (success) {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: 'Application Status',
                    icon: 'AlertCircleIcon',
                    text: 'Application status changed successfully',
                    variant: 'success',
                  },
                },
                { timeout: this.$longestTimeout },
              )
            } else {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: 'Application Status',
                    icon: 'AlertCircleIcon',
                    text: 'Application status change failed',
                    variant: 'danger',
                  },
                },
                { timeout: 1000 },
              )
            }
          })
          .catch(error => {})
      }
    },
    formChange() {
      const button = document.querySelector(
        '.wizard-footer-right > span > .wizard-btn',
      )

      const tab_index = this.$refs.wizard.activeTabIndex
      if (tab_index === 0) {
        if (button) {
          button.innerHTML = 'Skip'
        }
      } else if (button) {
        button.innerHTML = 'Next'
      }
    },
    getCredits() {
      this.$http
        .get('/api/credits')
        .then(response => {
          if (response.data.success) {
            this.credits = response.data.credits
          }
        })
        .catch(error => {})
    },
    specialCompanyChecks(group_type) {
      if (group_type == 'A') {
        const companies = [
          'DYNAMIC HUMAN CAPITAL PTE. LTD.',
          'PersolKelly',
          'FASTCO PTE. LTD.',
          'ELITEZ & ASSOCIATES PTE. LTD.',
          'ELITEZ PTE. LTD.',
          'ADECCO PERSONNEL PTE LTD',
        ]

        if (companies.includes(this.$store.state.auth.ActiveUser.company_name)) {
          return true
        }
      }

      return false
    },
    toggleBillSidebar() {
      this.sidebarActivated = false
    },
    getBillingInfo() {
      this.$http
        .get('/api/billing-info')
        .then(response => {
          if (response.data.success) {
            const results = response.data.output
            this.billing_info = results
            const neededKeys = [
              'phone_number',
              'email',
              'address_1',
              'first_name',
              'last_name',
              'company_name',
            ]

            if (
              neededKeys.every(key => Object.keys(this.billing_info).includes(key))
            ) {
              this.proceed_transaction = true
            } else {
              this.proceed_transaction = false
            }
          }
        })
        .catch(error => {})
    },
    subscribe() {
      this.getBillingInfo()
      this.successURL = `https://dashboard.headhuntershq.com/payment-success/${this.payment_id}/500`

      if (this.proceed_transaction) {
        this.$refs.checkoutRef.redirectToCheckout()
      } else {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Billing Notification',
              icon: 'AlertCircleIcon',
              text: 'Please update your billing information before subscribing',
              variant: 'danger',
            },
          },
          { timeout: 1000 },
        )

        this.sidebarActivated = true
      }
    },
    generate_payment_id() {
      this.$http
        .get('/api/payment-id/500')
        .then(response => {
          if (response.data.success) {
            this.payment_id = response.data.payment_id
          }
        })
        .catch(error => {})
    },
    buyCredits() {},

    sendWhich(which_channel) {
      this.send_where = which_channel
    },
    latest_update(val) {
      this.$forceUpdate()
    },
    showInfo(
      text,
      textType,
      applicationId,
      email,
      maskType,
      event,
      otherInfo,
    ) {
      const dom = event
      if (textType === 'contact') {
        if (maskType.includes('mask')) {
          const { phone_number, phone_number_verified } = this.$store.state.auth.ActiveUser

          if (phone_number_verified) {
            if (phone_number.toString().length !== 8) {
              this.update_popup = true
            } else {
              this.generateNumber(applicationId, text, phone_number)
              // event.target.innerHTML = number
              // this.onCopy(number)
            }
          } else {
            this.verifyType = 'phoneNumber'
            this.openVerifyPopup = true
            this.$store.dispatch('auth/getLoggedInUser', { router_app: this.$router.app, publicPage: this.$router.currentRoute.meta.allowAnonymous || null })
          }
        } else if (maskType.includes('unmask')) {
          dom.target.innerHTML = text
          this.onCopy(text)
        } else {
          dom.target.innerHTML = 'Hidden Info'
        }
      } else if (maskType.includes('mask')) {
        dom.target.innerHTML = otherInfo
        this.onCopy(text)
      } else if (maskType === 'unmask') {
        dom.target.innerHTML = text
        this.onCopy(text)
      } else {
        dom.target.innerHTML = 'Hidden Info'
      }

      const allData = { _id: applicationId }
      const { user_group } = this.$store.state.auth.ActiveUser
      if (['temporary'].some(el => user_group.includes(el))) {
        this.$http
          .post(`/api/contacted/${email}`, { data: allData })
          .then(response => {})
          .catch(error => {})
      }
    },

    createCompany() {
      this.restoreCreds()
      const { company_info } = this
      this.$http
        .post('/api/create-company', { data: company_info })
        .then(response => {
          const { success } = response.data
          if (success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Company Creation',
                  icon: 'AlertCircleIcon',
                  text: response.data.message,
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )

            this.add_new_company = false
            this.confirmUpload()
            this.$refs.uploadCSV.value = ''
            this.file_upload = ''
          } else {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Company Creation',
                  icon: 'AlertCircleIcon',
                  text: response.data.message,
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        })
        .catch(error => {})
    },
    downloadTemplate() {
      const company = this.$store.state.auth.ActiveUser.company_uen_no
      let template = ''
      if (company === this.$CompanyUen.E2I) {
        template = 'job_template.xlsm'
      } else if (this.specialCompanyChecks('A')) {
        template = 'persolkelly_template.xlsx'
      } else {
        template = 'others.xlsx'
      }

      this.$http
        .get(`/api/media/${template}`, { responseType: 'arraybuffer' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'job_template.xlsm')
          document.body.appendChild(fileLink)

          fileLink.click()
        })
    },
    extract_values() {
      const preferences = []
      let job_type = ''
      if (this.job_type.internship_traineeship) {
        preferences.push('internship_traineeship')
      }
      if (this.job_type.freelance) {
        preferences.push('freelance')
      }
      if (this.job_type.fulltime) {
        job_type = 'fulltime'
      }
      if (this.job_type.parttime) {
        job_type = 'parttime'
      }
      if (this.job_type.temporary) {
        preferences.push('temporary')
      }
      if (this.job_type.contract) {
        preferences.push('contract')
      }
      if (this.job_type.permanent) {
        preferences.push('permanent')
      }
      if (this.job_type.flexiwork) {
        preferences.push('flexiwork')
      }
      const target_channel = []

      for (const portal of this.all_portals) {
        if (this.optional.destination[portal]) {
          target_channel.push(portal)
        }
      }

      const all_published = []
      if (this.published_fields.employer) {
        all_published.push('employer')
      }

      if (this.published_fields.salary) {
        all_published.push('salary')
      }

      if (this.published_fields.vacancies) {
        all_published.push('vacancies')
      }

      const all_data = {
        position: this.position,
        description: this.description,
        image_url: this.image_url,
        job_type,
        preferences,
        requirements: this.requirements,
        work_days: this.work_days,
        work_hours: this.work_hours,
        min_salary: this.min_salary,
        salary: this.salary,
        yoe: this.yoe,
        job_level: this.job_level,
        work_location: this.work_location,
        remote: this.remote,
        published: all_published,

        vacancies: this.optional.vacancies,
        questions: this.optional.questions,
        target_channel,
        poster_email: this.$store.state.auth.ActiveUser.email,
        hiring_manager_email: this.optional.hiring_manager_email,
        job_industry: this.select_industry,
        employer: this.select_company.split('#')[0],
        uen_no: this.select_company.split('#')[1],
        // send_where: this.send_where
      }

      if (this.specialCompanyChecks('A')) {
        all_data.expiry = this.job_expiry
        all_data.client_profile = this.client_profile
      }

      return all_data
    },
    proceedShare(shared_data) {
      this.popupHiring = false
      this.check_shared(shared_data)
    },

    share_with_employer() {
      const hiring_details = this.shared_data
      this.$http
        .post('/api/share-application', {
          data: {
            all_ids: this.application_ids,
            hiring_details,
          },
        })
        .then(response => {
          const { success } = response.data
          if (success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Job Manager',
                  icon: 'AlertCircleIcon',
                  text: response.data.message,
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )
            this.hiring_manager_email = null
            this.shared_data = []
          } else {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Job Manager',
                  icon: 'AlertCircleIcon',
                  text: 'Could not share the applications with the employer',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        })
        .catch(error => {})
    },

    multiShare() {
      this.shared_data = {}
      const update_array = []
      const update_text = []
      let index = 1
      const all_applicants = []
      for (const item of this.selected_applicants) {
        const share_text = `${item.fullname} - ${item.email}`
        update_text.push(share_text)
        update_array.push(item.app_id)

        item.mask_email = `email_unmask_${index}`
        item.mask_contact = `contact_unmask_${index}`

        item.mask_email_unmask = `email_unmask_${index}`
        item.mask_email_mask = `email_mask_${index}`
        item.mask_email_hide = `email_hide_${index}`

        item.mask_contact_unmask = `contact_unmask_${index}`
        item.mask_contact_mask = `contact_mask_${index}`
        item.mask_contact_hide = `contact_hide_${index}`

        this.$set(this.shared_data, index, item)
        all_applicants.push(item)

        index += 1
      }
      if (update_array === undefined || update_array.length === 0) {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Row Selection.',
              icon: 'AlertCircleIcon',
              text: 'Please select at least one row to proceed.',
              variant: 'danger',
            },
          },
          { timeout: this.$longestTimeout },
        )
      } else {
        this.sharing_info = update_text.join('\n')
        this.application_ids = update_array
        if (!this.hiring_manager_email) {
          this.popupHiring = true
        } else {
          this.check_shared()
        }
      }
    },

    reset_form() {
      this.position = ''
      this.location = ''
      this.work_days = ''
      this.work_hours = ''
      this.work_location = ''
      this.description = ''
      this.select_date = ''
      this.select_tags = ''
      this.image_url = '';
      (this.client_profile = ''),
      (this.published_fields = {
        vacancies: true,
        salary: true,
        employer: false,
      }),
      (this.job_type = {
        parttime: false,
        freelance: false,
        fulltime: false,
        internship_traineeship: false,
        flexiwork: false,
        permanent: false,
        contract: false,
        temporary: false,
      })
      this.optional = {
        team: '',
        union: '',
        destination: {
          siso: false,
          pmet: false,
          non_pmet: false,
        },
        vacancies: '',
        poster_email: '',
        hiring_manager_email: '',
      }
      this.selected_employer = []
      this.requirements = ''
      this.salary = ''
      this.select_company = ''
      this.select_industry = []
    },
    editJob() {
      this.restoreCreds()
      const all_data = this.extract_values()
      const update_fields = {}

      for (const [key, value] of Object.entries(all_data)) {
        let equiv_key = ''
        if (key == 'work_hours') {
          equiv_key = 'work_time'
        } else if (key == 'work_location') {
          equiv_key = 'location'
        } else if (key == 'target_channel') {
          equiv_key = 'post_channel'
        } else {
          equiv_key = key
        }
        if (this.selected_job[equiv_key] != all_data[key]) {
          if (!['published', 'remote'].includes(key)) {
            // console.log(key, value);
            update_fields[key] = value
          }
        }
      }

      const update_array = []

      for (const item of this.selected_jobs) {
        update_array.push(item._id)
      }
      if (update_fields === undefined || update_fields.length === 0) {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Edit Notification',
              icon: 'AlertCircleIcon',
              text: 'No changes detected',
              variant: 'danger',
            },
          },
          { timeout: this.$longestTimeout },
        )
      } else {
        const company = this.$store.state.auth.ActiveUser.company_name
        this.restoreCreds()
        this.$http
          .put('/api/ats-jobs', {
            job_ids: update_array,
            update_values: update_fields,
            update_type: 'update',
          })
          .then(response => {
            const cleaner = response.data

            if (cleaner.success) {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: 'Operation Update',
                    icon: 'AlertCircleIcon',
                    text: 'You have edited the job(s) successfully',
                    variant: 'success',
                  },
                },
                { timeout: this.$longestTimeout },
              )
            }
          })
          .catch(error => {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Operation Failed',
                  icon: 'AlertCircleIcon',
                  text: 'Please try again later!',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          })
      }
    },
    changeAction(text) {
      this.action_text = text
      switch (text) {
        case 'Post Jobs':
          this.action_view = 'success'
          this.action_icon = 'add'
          break
        case 'Repost Jobs':
          this.action_view = 'primary'
          this.action_icon = 'redo'
          break

        case 'Edit Jobs':
          this.action_view = 'warning'
          this.action_icon = 'edit'
          break

        case 'Archive Jobs':
          this.action_view = 'danger'
          this.action_icon = 'archive'
          break
        case 'Actions':
          this.action_view = 'dark'
          this.action_icon = 'info_outline'
          break
        default:
          this.action_view = 'dark'
          this.action_icon = 'info_outline'
      }

      this.performAction()
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => {})
    },
    showApplicants(data) {
      const db_url_id = data.database_name ? `_${data.database_name}` : ''

      this.$router.push(`/applicant-tracking/applications/${data.id}${db_url_id}`)
      // this.appColumns = this.initAppColumns()
      // // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      // this.changeAction('Actions')
      // this.current_employer = data.employer
      // this.hiring_manager_email = data.hiring_manager_email
      // this.specified_position = data.position
      // this.applicants = data.applicants
      // this.applicants.forEach(val => {
      //   this.$watch(() => val, this.handleStatusChange, { deep: true })
      // })
      // this.view_applicants = true
      // this.toggleDataSidebar(true);
    },
    getInterviewColor(status) {
      status = status.toLowerCase()
      if (status === 'na') return 'warning'
      if (status === 'enabled') return 'success'
      if (status === 'disabled') return 'danger'
      return 'primary'
    },
    getStatusColor(num) {
      if (num === 'Contacted') return 'success'
      if (num === 'Received') return 'dark'
      if (num === 'Reviewed') return 'warning'
      if (num === 'Applied') return 'danger'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'dark'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
    confirmDeleteRecord(record_names, record_type) {
      this.$bvModal
        .msgBoxConfirm(
          `You are about to archive the following ${record_type} : \n ${record_names}`,
          {
            title: 'Confirm Archive',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Archive',
            cancelTitle: 'Cancel',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(value => {
          if (value) {
            this.deleteRowData()
          }
        })
    },

    confirmSharing(application_id, hiring_manager_emails, normal_share = true) {
      const cleaned_emails = hiring_manager_emails.join(', ')

      if (normal_share) {
        this.$bvModal
          .msgBoxConfirm(
            `You are about to share the following application(s): \n\n ${this.sharing_info}\n\n with ${cleaned_emails}. Do you want to proceed?`,
            {
              title: 'Confirm Application Share',
              size: 'sm',
              okVariant: 'warning',
              okTitle: 'Yes',
              cancelTitle: 'Cancel',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
            },
          )
          .then(value => {
            if (value) {
              this.share_with_employer()
            }
          })
      } else {
        this.$bvModal
          .msgBoxConfirm(
            `You have already shared the following application(s): \n\n ${this.sharing_info}\n\n with ${cleaned_emails}. Do you want to share the appliations once more?`,
            {
              title: 'Confirm Application Share',
              size: 'sm',
              okVariant: 'warning',
              okTitle: 'Yes',
              cancelTitle: 'Cancel',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
            },
          )
          .then(value => {
            if (value) {
              this.share_with_employer()
            }
          })
      }
    },

    show_applications() {
      this.view_resume = false
      this.view_applicants = true
    },
    async getStats() {
      this.isStatsLoading = true
      this.restoreCreds()
      const url = `/api/ats-stats/${this.which_data}`
      this.$http
        .get(url)
        .then(response => {
          if (response.data.success) {
            const { stats } = response.data
            this.statistics = [
              {
                title: 'Total Jobs',
                stats: stats.total_jobs,
                icon: 'DatabaseIcon',
                color: 'light-dark',
              },
              {
                title: 'Open Jobs',
                stats: stats.open_jobs,
                icon: 'FileTextIcon',
                color: 'light-warning',
              },
              {
                title: 'Applications',
                stats: stats.total_applications,
                icon: 'PieChartIcon',
                color: 'light-primary',
              },
              {
                title: 'Interviews Conducted',
                stats: stats.interviews,
                icon: 'VideoIcon',
                color: 'light-success',
              },
              {
                title: 'Applicant Sources',
                stats: stats.sources,
                icon: 'CloudIcon',
                color: 'light-danger',
              },
            ]
          }
          this.isStatsLoading = false
        })
        .catch(() => {
          this.isStatsLoading = false
        })
    },
    async getJobs() {
      this.isLoading = true
      this.restoreCreds()

      const query = `?params=${JSON.stringify(this.serverParams)}`
      const url = `/api/ats-jobs/${this.which_data}${query}`

      this.$http
        .post(url, { data: this.sort_search_options })
        .then(response => {
          if (response.data.success) {
            const { jobs, totalRecords } = response.data
            this.jobs = jobs
            this.totalRecords = totalRecords
            // this.total_open_jobs = this.which_data ? jobs.length : stats.jobs

            this.trafficSources = [
              {
                name: 'Facebook',
                icon: 'FacebookIcon',
                ratio: sources.facebook,
                color: 'warning',
              },
              {
                name: 'Twitter',
                icon: 'TwitterIcon',
                ratio: sources.twitter,
                color: 'warning',
              },
              {
                name: 'Linkedin',
                icon: 'LinkedinIcon',
                ratio: sources.linkedin,
                color: 'warning',
              },
              {
                name: 'Instagram',
                icon: 'InstagramIcon',
                ratio: sources.instagram,
                color: 'warning',
              },
              {
                name: 'Telegram',
                icon: 'SendIcon',
                ratio: sources.telegram,
                color: 'warning',
              },
              {
                name: 'Others',
                icon: 'CloudIcon',
                ratio: sources.others,
                color: 'warning',
              },
            ]
          }

          this.jobs = []
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    },
    handleInput() {
      const text = document.getElementsByClassName(
        'input-select v-select--input',
      )[0].value

      this.getEmployers(text)
    },

    restoreCreds() {
      const { token } = this.$store.state.auth.ActiveUser
      this.$http.defaults.headers.common.Authorization = `Token ${token}`
    },

    getEmployers(query) {
      this.employers = []
      this.restoreCreds()
      this.$http
        .get(`/api/company-search/${query}`)
        .then(response => {
          if (response.data.success) {
            for (const item of response.data.data) {
              this.employers.push({
                text: item.text,
                value: item.value,
              })
            }
          } else {
            this.event_exist = false
          }
        })
        .catch(error => {})
    },
    check_rights() {
      // let checker = (arr, target) => target.every((v) => arr.includes(v));
      const { permissions } = this.$store.state.auth.ActiveUser
      const currentPagePermission = permissions.filter(item => item.section === 'ATS System')[0]
      const currentPermission = currentPagePermission.read
      if (currentPermission) {
        return true
      }
      return true
    },
    removeRows(delete_ids) {
      const ids = []
      delete_ids.forEach(item => { ids.push(item._id) })
      this.jobs = this.jobs.filter(item => !ids.includes(item._id))
    },
    deleteRowData() {
      
      const del_array = this.items_deletion.map(item => item)
      this.items_deletion = []

      this.restoreCreds()
      this.$http
        .put('/api/ats-jobs', {
          job_ids: del_array,
          update_type: 'delete',
        })
        .then(response => {
          const info = response.data

          if (info.success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Operation Update',
                  icon: 'AlertCircleIcon',
                  text: 'You have archived the jobs successfully',
                  variant: 'success',
                },
              },
              { timeout: this.$longestTimeout },
            )
            // this.removeRows(del_array)
            this.getJobs()
          }
        })
        .catch(error => {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Operation Failed',
                icon: 'AlertCircleIcon',
                text: 'Please try again later!',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        })
    },

    performAction() {
      if (this.action_text === 'Archive Jobs') {
        if (this.check_rights('delete')) {
          const rows = this.selected_jobs
          if (!rows || !rows.length) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Row Selection.',
                  icon: 'AlertCircleIcon',
                  text: 'Please select at least one row to proceed.',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          } else {
            const selected = this.selected_jobs
            let message = ''
            let count = 1
            for (const item of selected) {
              this.items_deletion.push(item)
              message += `\n${count} - ${item.position}\n`
              count += 1
            }
            this.confirmDeleteRecord(message, 'jobs')
          }
        } else {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Inadequate permission',
                icon: 'AlertCircleIcon',
                text: 'You dont have enough rights to delete the data in this section',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        }
      } else if (this.action_text === 'Post Jobs') {
        // this.reset_form();
        // this.popupActive = true;
        // this.show_bulk = true;
        this.$router.push('/applicant-tracking/edit-job')
      } else if (this.action_text === 'Edit Jobs') {
        this.show_bulk = false
        const rows = this.selected_jobs
        if (!rows || !rows.length) {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Row Selection.',
                icon: 'AlertCircleIcon',
                text: 'Please select at least one row to proceed.',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        } else {
          if (this.selected_jobs.length > 1) {
            this.$toastWarning('ATS Operation', 'Please select only one job.')
            return
          }
          const selected = this.selected_jobs.length === 1 ? this.selected_jobs[0] : {}

          this.$store.dispatch('auth/createSelectedJob', selected).catch(err => {})
          if (selected !== null) {
            // this.$router.push(`/applicant-tracking/edit-job/${selected.id}_${selected.source_name}`)
            this.$router.push(`/applicant-tracking/edit-job/${selected.id}`)
            // this.$router.push({ name: 'applicant-tracking-system-edit-specific', params: {job_id: selected._id, job: selected } })
          }

          this.title = 'Edit Job'
          this.popupActive = true
          this.action = 'update'
        }
      } else if (this.action_text === 'Repost Jobs') {
        const company = this.$store.state.auth.ActiveUser.company_name
        const rows = this.selected_jobs
        if (!rows || !rows.length) {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Row Selection.',
                icon: 'AlertCircleIcon',
                text: 'Please select at least one row to proceed.',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        } else {
          this.restoreCreds()
          this.$http
            .put('/api/ats-jobs', {
              job_ids: rows,
              update_type: 'repost',
            })
            .then(response => {
              const cleaner = response.data
              if (cleaner.success) {
                this.$toast(
                  {
                    component: this.$toastContent,
                    props: {
                      title: 'Repost Update',
                      icon: 'AlertCircleIcon',
                      text: 'The job(s) have been reposted successfully!',
                      variant: 'success',
                    },
                  },
                  { timeout: this.$longestTimeout },
                )
                this.getJobs()
              }
            })
            .catch(error => {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: 'Operation Failed',
                    icon: 'AlertCircleIcon',
                    text: 'Please try again later!',
                    variant: 'danger',
                  },
                },
                { timeout: this.$longestTimeout },
              )
            })
        }
      } else if (this.action_text === 'Add Record') {
        if (this.check_rights('write')) {
          this.popupActive = true
        } else {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Inadequate permission',
                icon: 'AlertCircleIcon',
                text: 'You dont have enough rights to add new data in this section',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        }
      } else if (this.action_text === 'Share with others') {
        this.multiShare()
      } else if (
        this.action_text === 'Boost Jobs'
        || this.action_text === 'Boost Job'
      ) {
        const company = this.$store.state.auth.ActiveUser.company_name
        const rows = this.selected_jobs
        if ((!rows || !rows.length) && this.action_text === 'Boost Jobs') {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Row Selection.',
                icon: 'AlertCircleIcon',
                text: 'Please select at least one row to proceed.',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        } else {
          this.boost_popup = true
        }
      }
    },

    editATSJob(row) {
      this.selected_jobs = [row]

      this.show_bulk = false
      const rows = this.selected_jobs
      if (!rows || !rows.length) {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Row Selection.',
              icon: 'AlertCircleIcon',
              text: 'Please select at least one row to proceed.',
              variant: 'danger',
            },
          },
          { timeout: this.$longestTimeout },
        )
      } else {
        if (this.selected_jobs.length > 1) {
          this.$toastWarning('ATS Operation', 'Please select only one job.')
          return
        }
        const selected = this.selected_jobs.length === 1 ? this.selected_jobs[0] : {}

        this.$store.dispatch('auth/createSelectedJob', selected).catch(err => {})
        if (selected !== null) {
          const db_url_id = selected.database_name ? `_${selected.database_name}` : ''

          // this.$router.push(`/applicant-tracking/edit-job/${selected.id}_${selected.source_name}`)
          this.$router.push(`/applicant-tracking/edit-job/${selected.id}${db_url_id}`)
          // this.$router.push({ name: 'applicant-tracking-system-edit-specific', params: {job_id: selected._id, job: selected } })
        }

        this.title = 'Edit Job'
        this.popupActive = true
        this.action = 'update'
      }
    },

    repostATSJob(row) {
      this.selected_jobs = [row]
      const company = this.$store.state.auth.ActiveUser.company_name
      const rows = this.selected_jobs
      if (!rows || !rows.length) {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Row Selection.',
              icon: 'AlertCircleIcon',
              text: 'Please select at least one row to proceed.',
              variant: 'danger',
            },
          },
          { timeout: this.$longestTimeout },
        )
      } else {
        // const repost_array = []
        // for (const item of rows) {
        //   const db_url_id = item.database_name ? `_${item.database_name}` : ''

        //   repost_array.push(item.id + db_url_id)
        // }
        this.restoreCreds()
        this.$http
          .put('/api/ats-jobs', {
            job_ids: rows,
            update_type: 'repost',
          })
          .then(response => {
            const result = response.data
            if (result.success) {
              this.$toast(
                {
                  component: this.$toastContent,
                  props: {
                    title: 'Repost Update',
                    icon: 'AlertCircleIcon',
                    text: 'Job has been reposted successfully!',
                    variant: 'success',
                  },
                },
                { timeout: this.$longestTimeout },
              )
              this.getJobs()
            }
          })
          .catch(error => {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Operation Failed',
                  icon: 'AlertCircleIcon',
                  text: 'Please try again later!',
                  variant: 'danger',
                },
              },
              { timeout: this.$longestTimeout },
            )
          })
      }
    },

    deleteATSJob(row) {
      this.selected_jobs = [row]

      if (this.check_rights('delete')) {
        const rows = this.selected_jobs
        if (!rows || !rows.length) {
          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Row Selection.',
                icon: 'AlertCircleIcon',
                text: 'Please select at least one row to proceed.',
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )
        } else {
          const selected = this.selected_jobs
          let message = ''
          let count = 1
          for (const item of selected) {
            this.items_deletion.push(item)
            message += `${item.position}\n`
            count += 1
          }
          this.confirmDeleteRecord(message, 'job')
        }
      } else {
        this.$toast(
          {
            component: this.$toastContent,
            props: {
              title: 'Inadequate permission',
              icon: 'AlertCircleIcon',
              text: 'You dont have enough rights to delete the data in this section',
              variant: 'danger',
            },
          },
          { timeout: this.$longestTimeout },
        )
      }
    },

    uploadJobs(input) {
      this.file_upload = input
      this.$toast(
        {
          component: this.$toastContent,
          props: {
            title: 'File Attachment',
            icon: 'AlertCircleIcon',
            text: 'File attached successfully. Click on the Next button to select the platform to post.',
            variant: 'success',
          },
        },
        { timeout: this.$longestTimeout },
      )
    },
    cancelUpload() {
      this.file_upload = ''
      this.$refs.uploadCSV.value = ''
      this.$toast(
        {
          component: this.$toastContent,
          props: {
            title: 'File Upload Status',
            icon: 'AlertCircleIcon',
            text: 'File upload cancelled.',
            variant: 'success',
          },
        },
        { timeout: this.$longestTimeout },
      )
    },
    showBulk() {
      this.show_bulk = true
      this.popupActive = true
    },
    initJobColumns() {
      let allColumns = []
      // eslint-disable-next-line prefer-const
      if (this.$store.state.auth.ActiveUser.company_name === 'PersolKelly') {
        allColumns = [
          {
            label: 'Applications',
            field: 'applications',
            filterOptions: {
              enabled: false,
              placeholder: '',
              trigger: 'enter',
            },
            sortable: false,
          },
          {
            label: 'Position',
            field: 'position',

            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Posted Channel',
            field: 'post_channel',

            sortable: false,
            filterOptions: {
              enabled: false,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Job Owner Name',
            field: 'poster',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Job Owner Team',
            field: 'team',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Company Name',
            field: 'employer',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Days left to closure',
            field: 'days',
            filterOptions: {
              enabled: false,
              placeholder: '',
              trigger: 'enter',
              // filterFn: function(data, filterString) {
              //   console.log(filterString)
              //   var x = parseInt(filterString)
              //   return data >= x - 5 && data <= x + 5;
              // },
            },
            sortable: false,
          },
          // {
          //   label: 'Interview Enabled',
          //   field: 'interview',
          //   filterOptions: {
          //     enabled: false,
          //     placeholder: '',
          //     trigger: 'enter',
          //   },
          // },
          {
            label: 'Actions',
            field: 'actions',
            sortable: false,
          },
        ]
      } else {
        allColumns = [
          {
            label: 'Applications',
            field: 'applications',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Position',
            field: 'position',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Posted Channel',
            field: 'post_channel',

            sortable: false,
            filterOptions: {
              enabled: false,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Job Owner Name',
            field: 'job_owner_name',
            filterOptions: {
              trigger: 'enter',
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Company Name',
            field: 'company_name',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
            },
          },
          {
            label: 'Days left to closure',
            field: 'days',
            filterOptions: {
              enabled: true,
              placeholder: '',
              trigger: 'enter',
              // filterFn: function(data, filterString) {
              //   var x = parseInt(filterString)
              //   return data >= x - 5 && data <= x + 5;
              // }
            },
          },
          // {
          //   label: 'Interview Enabled',
          //   field: 'interview',
          //   filterOptions: {
          //     enabled: true,
          //     placeholder: '',
          //     trigger: 'enter',
          //     filterDropdownItems: [
          //       { text: 'Enabled', value: true },
          //       { text: 'Disabled', value: false },
          //     ],
          //   },

          // },
          {
            label: 'Actions',
            field: 'actions',
            width: '22ch',
            sortable: false,
            filterOptions: {
              enabled: false,
              placeholder: '',
            },
          },
        ]
      }

      return allColumns
    },
    initAppColumns() {
      let allColumns = []
      // eslint-disable-next-line prefer-const

      let hiring_ag_only = []
      let hide_now = []
      if (this.$store.state.auth.ActiveUser.account_type === this.$UserGroups.AGENCY) {
        hiring_ag_only = [{
          label: 'View Activity',
          field: 'view_activity',
          thClass: 'shorterColumnWidth',
        }]
      }
      let internalStatus = []
      let sharedStatus = []
      let note = []

      if (!this.hide_for_now) {
        hide_now = [{
          label: 'Actions',
          field: 'actions',
        }]
        if (this.$store.state.auth.ActiveUser.account_type === this.$UserGroups.AGENCY) {
          internalStatus = [
            {
              label: 'Internal Status',
              field: 'internal_status',
              filterOptions: {
                enabled: true,
                placeholder: '',
              },

              thClass: 'columnWidth',
            },
          ]
          sharedStatus = [
            {
              label: 'Shared Status',
              field: 'status_reviewed',
              filterOptions: {
                enabled: true,
                placeholder: '',
              },
              thClass: 'columnWidth',
            },
          ]
        } else {
          sharedStatus = [
            {
              label: 'Status',
              field: 'status',
              filterOptions: {
                enabled: true,
                placeholder: '',
              },
              thClass: 'columnWidth',
            },
          ]
        }
      } else {
        note = [
          {
            label: 'Note',
            field: 'note',
            filterOptions: {
              enabled: true,
              placeholder: '',
            },
            thClass: 'columnWidth',
          },
        ]
      }
      allColumns = [
        {
          label: 'Full Name',
          field: 'fullname',
          filterOptions: {
            enabled: true,
            placeholder: '',
          },
          thClass: 'columnWidth',
        },
        {
          label: 'Email Address',
          field: 'email',
          filterOptions: {
            enabled: true,
            placeholder: '',
          },
          thClass: 'columnWidth',
        },
        {
          label: 'Contact',
          field: 'contact',
          filterOptions: {
            enabled: true,
            placeholder: '',
          },
          thClass: 'shorterColumnWidth',
        },
        ...note,
        ...internalStatus,
        ...sharedStatus,
        {
          label: 'Applied On',
          field: 'date',
          filterOptions: {
            enabled: true,
            placeholder: '',
          },
          thClass: 'shorterColumnWidth mx-1',
        },
        {
          label: 'View Resume',
          field: 'view_resume',
          thClass: 'shorterColumnWidth',
        },
        ...hiring_ag_only,
        ...hide_now,
      ]

      return allColumns
    },
  },
}
</script>

<style lang="scss" scoped>
.vs__dropdown-menu{
    position: relative!important;
    z-index: 100!important;
    margin-top: -12.5em!important;
}
.columnWidth{
  min-width: 300px!important;
}

.shorterColumnWidth{
  min-width: 200px!important;
}
.icon-spacing{
  margin-top: 3px;
}

.overflow-ats {
    // display: flex;
    // min-width: 70em;

    display: flex;
    // flex-wrap: wrap;
    // flex-direction: column;
    overflow-x: scroll;
    -webkit-overflow-scrolling: auto ;

  }


@for $i from 0 through 100 {
  .progress-bar-custom-#{$i} {
      background-color: rgba((255 - (255 * ($i/100))), (0 + (255 * ($i/100))), 50, 0.2);

    .progress-bar {
      background-color: rgba((255 - (255 * ($i/100))), (0 + (255 * ($i/100))), 50, 0.9);
    }
  }
}
</style>
